// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFound-NotFound-t8ykMK","NotFound_fourthree":"NotFound-NotFound_fourthree-2W1RLB NotFound-NotFound-t8ykMK","Button":"NotFound-Button-2UFfgX"};